import React, { Component } from 'react';
import ReactDOMServer from 'react-dom/server';
import { db } from '../../firebase';
import { PDFExport } from '@progress/kendo-react-pdf';
import Breadcrumbs from '../../components/breadcrumbs';
import { Link } from 'react-router-dom';
import { average, getChartOptions, collectRadarCaptionsData } from '../../helpers';
import LoadingState from '../../components/global/loading-state';
import withAuthorisation from '../../components/withauthorisation';
import ReportPageTemplate from './reportpagetemplate.jsx';
import TitlePage from '../../components/reports/TitlePage';
import PageHeader from '../../components/reports/PageHeader';
import Contents from '../../components/reports/Contents';
import DottedLines from '../../components/reports/DottedLines';
import Goals from '../../components/reports/Goals';
import GoalProgress from '../../components/reports/GoalProgress';
import DetailedFeedbackSection from '../../components/reports/detailedFeedbackSection';
import RelationshipCompetencyComparison from '../../components/charts/RelationshipCompetencyComparison';
import RankedCompetencies from '../../components/reports/RankedCompetencies';
import PDFExportButton from '../../components/reports/PDFExportButton';
const authCondition = (authUser) => !!authUser;

class SelfReport extends Component {
  constructor(props) {
    super(props);
    this.exportPDF = this.exportPDF.bind(this);
    this.convertSVGToImage = this.convertSVGToImage.bind(this);
    this.updateCompetencyComparisonPDFExportPreRenderStatus = this.updateCompetencyComparisonPDFExportPreRenderStatus.bind(this);
    this.updateRankedCompetenciesPDFExportPreRenderStatus = this.updateRankedCompetenciesPDFExportPreRenderStatus.bind(this);
    this.updateDetailedFeedbackPDFExportPreRenderStatus = this.updateDetailedFeedbackPDFExportPreRenderStatus.bind(this);

    this.state = {
      loading: true,
      error: false,
      captions: {},
      userData: {},
      userId: null,
      groupId: null,
      current360Id: null,
      current360Relationships: this.props.current360Relationships,
      sectionsLegacyMode: false,
      pdfRequested: false,
      competencyComparisonPDFRenderCompleted: false,
      rankedCompetenciesPDFRenderCompleted: false,
      detailedFeedbackPDFRenderCompleted: false,
      layoutMode: 'default'
    };
  }
  exportPDF = () => {
    if (this.state.layoutMode !== 'pdfCompleted') {
      // triggers re-render process to split each question into pages that account for overflow
      this.setState({pdfRequested: true, layoutMode: 'pdfRecalculate'})
    }
  };
  convertSVGToImage = (htmlString) => {
    try {
      // Take an SVG html string, convert it to static markup
      let staticRadarChart = ReactDOMServer.renderToStaticMarkup(htmlString);

      // Convert SVG string into a data URI
      const svgDataUri = `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(staticRadarChart)))}`;

      return svgDataUri;
    } catch (err) {
      return null;
    }
  };
  componentDidMount() {
    const {
      match: { params },
    } = this.props;
    this.setState({
      userId: params.userId,
      groupId: params.groupId,
      current360Id: params.id,
    });

    db.doGetCurrentGroup(this.props.match.params.accountId, params.id, params.groupId).onSnapshot((snapshot) => {
      if (snapshot.data()) {
        this.setState({
          currentGroup: snapshot.data(),
        });

        db.getUserFromGroup(params.accountId, params.userId).onSnapshot((snapshot) => {
          let userFullName = `${snapshot.data()['forename']} ${snapshot.data()['surname']}`;
          let reportPdfFileName = `${snapshot.data()['forename']}-${snapshot.data()['surname']}-self-report.pdf`;

          db.doGetCurrent360(params.accountId, params.id).then((snapshot) => {
            let questionnaireID = snapshot.data()['questionnaireID'];
            let current360Title = snapshot.data()['title'];
            let sectionsLegacyMode = false;

            db.doGetSectionsAndQuestionDetailsList(params.accountId, questionnaireID).then((sections) => {
              if (
                Object.values(sections)
                  .map((section) => section.sortOrder)
                  .includes(undefined)
              ) {
                sectionsLegacyMode = true;
              }

              let questionnaireSections = sections;
              let captions = {};
              let descriptions = {};
              let questionDetails = {};
              let sectionDetails = questionnaireSections;
              let userAnswers = {};
              let userResponses = {};
              let userCommentsBySection = {};
              let userIndividualAnswers = {};
              let freeTextQuestionDetails = {};

              Object.keys(questionnaireSections).map((key, index) => {
                let sectionID = key;

                if (questionnaireSections[sectionID].questions) {
                  // Check if only one question AND if that question is a FreeText field!!
                  if (Object.keys(questionnaireSections[sectionID].questions).length == 1) {
                    // MAD:
                    if (questionnaireSections[sectionID].questions[Object.keys(questionnaireSections[sectionID].questions)[0]].answerType === 'FreeText') {
                      // Adds question to freeText questions
                      for (const qid in questionnaireSections[sectionID].questions) {
                        freeTextQuestionDetails[qid] = questionnaireSections[sectionID].questions[qid];
                      }
                      return;
                    }
                  }
                  // Set captions + description!
                  captions[[sectionID]] = questionnaireSections[sectionID].title;
                  descriptions[[sectionID]] = questionnaireSections[sectionID].description;

                  Object.keys(questionnaireSections[sectionID].questions).map((key, index) => {
                    const {answerType} = questionnaireSections[sectionID].questions[key];
                    // adds any other freetext questions to freeTextQuestionDetails object
                    if (answerType === 'FreeText') {
                      freeTextQuestionDetails[key] = questionnaireSections[sectionID].questions[key];
                    }
                    questionDetails[[key]] = questionnaireSections[sectionID].questions[key];
                  });
                }
              });
              // Get answers!

              // This updates state for captions, sectionDetails, radarSortedSectionIDs, numberOfRadarSections, captionKeysList
              const radarCaptionsData = collectRadarCaptionsData(captions, sectionsLegacyMode, sectionDetails);

              db.doGetUserAnswersBySections(
                params.accountId,
                params.userId,
                params.id,
                params.groupId,
                questionnaireID,
                'self-review',
                questionnaireSections
              ).then((data) => {
                let questionnaireSections = data;

                Object.keys(questionnaireSections).map((key, index) => {
                  let sectionKey = key;
                  let answers = [];
                  let responses = [0, 0, 0, 0, 0, 0];
                  let answerKey = 0;

                  Object.keys(questionnaireSections[sectionKey].answers).map((key, index) => {
                    let answerVal = questionnaireSections[sectionKey].answers[key];
                    // If answer is a number value (IE: not a text field) then set, otherwise set to `0`

                    answerVal = isNaN(Number(answerVal)) ? -1 : parseInt(answerVal);

                    if (answerVal == -1) {
                      let userComment = questionnaireSections[sectionKey].answers[key];

                      if (!userCommentsBySection[[sectionKey]]) {
                        userCommentsBySection[[sectionKey]] = {};
                      }
                      if (!userCommentsBySection[[sectionKey]][[key]]) {
                        userCommentsBySection[[sectionKey]][[key]] = {};
                        userCommentsBySection[[sectionKey]][[key]]['title'] = sectionDetails[sectionKey].questions[key].questionTitle;
                      }

                      userCommentsBySection[[sectionKey]][[key]]['comment'] = userComment;
                    } else {
                      if (!isNaN(parseInt(answerVal))) {
                        responses[answerVal] = responses[answerVal] + 1;
                      }
                      // user `answerKey` instead of `key` to ensure correct average

                      if (answerVal.toString() !== 'NaN') {
                        answers[answerKey] = answerVal;
                        userIndividualAnswers[key] = answerVal;
                      }

                      answerKey++;
                    }
                  });
                  if (answers.length) {
                    userAnswers[[sectionKey]] = average(answers) / 5;
                  } else {
                    userAnswers[[sectionKey]] = 0;
                  }
                  userResponses[[sectionKey]] = responses;
                });

                const weightedHighest = Object.entries(userIndividualAnswers)
                  .filter((q) => q[1] > 0)
                  .sort((a, b) => b[1] - a[1])
                  .map((q) => q[0]);

                let secLengthNoFreeText = {};
                let generateGraph = false;
                Object.keys(sectionDetails).forEach((item) => {
                  const questionsObj = sectionDetails[item].questions;
                  const multiChoiceQuestionsLength = Object.values(questionsObj).filter((question) => question.answerType === 'MultiChoice').length;
                  secLengthNoFreeText[item] = multiChoiceQuestionsLength;
                  if (multiChoiceQuestionsLength > 0) {
                    generateGraph = true;
                  }
                });
                this.setState({
                  sectionDetails: sectionDetails,
                  questionDetails: questionDetails,
                  freeTextQuestionDetails,
                  userResponses: userResponses,
                  userAnswers: userAnswers,
                  userFullName: userFullName,
                  reportPdfFileName: reportPdfFileName,
                  captions: captions,
                  current360Title: current360Title,
                  descriptions: descriptions,
                  generateGraph: generateGraph,
                  userCommentsBySection: userCommentsBySection,
                  secLengthNoFreeText: secLengthNoFreeText,
                  userIndividualAnswers: userIndividualAnswers,
                  weightedHighest: weightedHighest,
                  sectionsLegacyMode,
                  ...radarCaptionsData,
                  loading: false,
                });
              });
            });
          });
        });
      }
    });
  }
  componentDidUpdate(prevProps, prevState) {
    // run initial updates for pdfRenderCompleted when the both the radar chart captions and detailed feedback sections are finished
    if (
        !this.state.pdfRenderCompleted &&
        (
          (prevState.competencyComparisonPDFRenderCompleted !== this.state.competencyComparisonPDFRenderCompleted) 
          || 
          (prevState.rankedCompetenciesPDFRenderCompleted !== this.state.rankedCompetenciesPDFRenderCompleted)
          ||
          (prevState.detailedFeedbackPDFRenderCompleted !== this.state.detailedFeedbackPDFRenderCompleted) 
        )
      ) {
        if (
          this.state.competencyComparisonPDFRenderCompleted 
          && this.state.rankedCompetenciesPDFRenderCompleted 
          && this.state.detailedFeedbackPDFRenderCompleted
        ) {
          this.setState({ layoutMode: 'PDFRender' })
        }
      } else if (this.state.layoutMode === 'PDFRender') {
        const saveReport = async () => {
          await this.report.save();
          this.setState({layoutMode: 'pdfCompleted'})
          return;
        }
        saveReport();
      }
  }
  updateCompetencyComparisonPDFExportPreRenderStatus() {
    this.setState({competencyComparisonPDFRenderCompleted: true})
  }
  updateRankedCompetenciesPDFExportPreRenderStatus() {
    this.setState({rankedCompetenciesPDFRenderCompleted: true})
  }
  updateDetailedFeedbackPDFExportPreRenderStatus() {
    this.setState({detailedFeedbackPDFRenderCompleted: true})
  }

  render() {
    const {generateGraph, relationshipKeys, current360Relationships, sectionsLegacyMode, sectionDetails, pdfRequested, radarSortedSectionIDs, captionKeysList, layoutMode} = this.state;
    if (!this.state.loading) {
      let withoutZero = {};
      let userData = {};
      Object.keys(this.state.userResponses).forEach((key) => {
        let arr = 0;
        let countArr = 0;
        [...this.state.userResponses[key]].reverse().forEach((val, i) => {
          const n = 5 - i;
          if (n > 0 && val * n > 0) {
            arr += val * n;
            countArr += val;
          }
        });
        withoutZero[key] = arr / countArr;
        userData[key] = arr / countArr / 5;
      });

      let emptyData = {
        data: {},
        meta: {},
      };
      // let userData = this.state.userAnswers;
      let chartCaptions = this.state.captions;
      const data = [
        {
          data: {},
          meta: { color: 'blue' },
        },
      ];
      for (const q in this.state.sectionDetails) {
        let counter = 0;
        for (const p in this.state.sectionDetails[q].questions) {
          if (this.state.sectionDetails[q].questions[p].answerType === 'MultiChoice') {
            counter++;
          }
        }
        if (counter === 0) {
          delete userData[q];
          delete chartCaptions[q];
        }
      }
      const captionsLoaded = chartCaptions;
      data[0]['data'] = userData;

      const chartOptions = getChartOptions(captionsLoaded, radarSortedSectionIDs, 14);


      return (
        <div className='page-wrapper page-wrapper--report'>
          <section className='container container--slim'>
            <Breadcrumbs
              current360={this.props.current360}
              accountData={this.props.accountData}
              current360Groups={this.props.current360Groups}
              current360Relationships={this.props.current360Relationships}
              links={[
                {
                  title: 'Dashboard',
                  to: `/dashboard/${this.props.match.params.accountId}`,
                },
                {
                  title: `${this.props.accountData.accountTitle ? this.props.accountData.accountTitle : this.props.accountData.title} ${
                    this.props.current360.type
                  } Projects`,
                  to: `/dashboard/${this.props.match.params.accountId}/${this.props.current360.type === 'Goal Tracker' ? 'goal-tracker' : '360'}-projects/`,
                },
                {
                  title: this.props.current360.title,
                  to: '../../../../edit/',
                },
                {
                  title: this.state.currentGroup.title,
                  to: `../../../../edit/group/${this.state.groupId}/`,
                },
                {
                  title: `Self-Report & Development plan for ${this.state.userFullName}`,
                  to: null,
                },
              ]}
            />
          </section>
          <div
            className='user-report-view-only'
            style={{ height: '100vh', width: '100vw', paddingTop: 20, paddingBottom: 100, backgroundColor: 'rgb(82, 86, 89)', overflow: 'hidden' }}
          >
            <div className='tc' style={{ marginBottom: '1.4em' }}>
              <Link className='btn btn--back btn--white ml2 mr3' to={`../../../../edit/group/${this.state.groupId}/`}>
                Back to group overview
              </Link>
              <PDFExportButton pdfRequested={pdfRequested} layoutMode={layoutMode} exportFunction={this.exportPDF} />
            </div>
            <div
              style={{
                maxWidth: '210mm',
                height: '90vh',
                backgroundColor: 'white',
                boxShadow: '0px 0px 5px #000',
                marginLeft: 'auto',
                marginRight: 'auto',
                marginBottom: 100,
                padding: '0px',
                overflowX: 'scroll',
                overflowY: 'scroll',
              }}
            >
              <PDFExport
                paperSize={'A4'}
                forcePageBreak='.page-break'
                keepTogether={'div'}
                margin={{ bottom: 50 }}
                pageTemplate={ReportPageTemplate}
                fileName={this.state.reportPdfFileName}
                title=''
                subject=''
                keywords=''
                ref={(r) => (this.report = r)}
              >
                <div
                  className='user-report'
                  style={{
                    height: '100%',
                    width: '100%',
                    padding: '0px',
                  }}
                >
                  <header className='user-report__header'>
                    <img crossOrigin='anonymous' src={this.props.current360.settings.logo} className='header-logo-img' />
                    <div className='w-80'>
                      <h1 className='user-report__header-title'>{this.state.current360Title}</h1>
                      <p className='user-report__header-sub-title'>
                        <strong>Self-Report & Development plan</strong>
                      </p>
                      <p className='user-report__header-name'>For {this.state.userFullName}</p>
                    </div>
                  </header>
                  <Contents partTitles={['Your Feedback Summary', 'Your Detailed Feedback', 'Your Development Plan']} />

                  <TitlePage h2Text='Introduction' />

                  {/* introduction */}
                  <div className='bg-white user-report__content'>
                    <PageHeader h2Class='mt4' h2Text={<strong>Introduction</strong>} h3Text='Getting the most from your feedback' line={true} />

                    <h3 className='f5 mt4'>
                      <strong>Where to begin?</strong>
                    </h3>
                    <p>
                      It’s a good idea to read the report in the order provided. However, you may prefer to dive into a specific section and then pull out
                      related information from other parts of the report. You can see how the different elements of the report relate to each other, in the
                      section ‘How your report is compiled’.
                    </p>

                    <h3 className='f5 mt4'>
                      <strong>Make notes</strong>
                    </h3>
                    <p>
                      There are coaching questions throughout the report, these are provided to encourage you to reflect on your assessment. Additionally, the
                      report provides space for you to capture notes, as you read through.
                    </p>

                    <h3 className='f5 mt4'>
                      <strong>Build your development plan</strong>
                    </h3>
                    <p>
                      Your self-report will help you to learn, develop and grow. Take the time to consider how you can use the assessment to help shape your
                      future development. What is your report telling you about your opportunities to develop? Reflect on how you can put this into action, by
                      fleshing out your development plan with practical and positive actions and activities.
                    </p>

                    <h3 className='f5 mt4'>
                      <strong>Don’t be afraid to ask for help</strong>
                    </h3>
                    <p>
                      Asking for help is a positive step! If you are unsure about some of the report or feel uncertain about how to proceed with your goals;
                      talk to a trusted colleague, manager, coach or colleague within HR/Learning. Book some time to sit down and discuss your concerns and ask
                      them for help with your progression. If needed, they can help you to build some effective developmental solutions in response to your
                      report.
                    </p>

                    <PageHeader h2Class='mt4 page-break' h2Text={<strong>Introduction</strong>} h3Text='How your report is compiled' line={true} />

                    <h3 className='f5 mt4'>
                      <strong>Two things to note</strong>
                    </h3>
                    <p>Your feedback is made up of two key elements: competencies and statements.</p>

                    <h3 className='f5 mt4'>
                      <strong>Competencies</strong>
                    </h3>
                    <p>Competencies are high-level collections/groups of skills or knowledge. Each competency is made up of a series of statements.</p>

                    <h3 className='f5 mt4'>
                      <strong>Statements</strong>
                    </h3>
                    <p>Statements are a series of actions or behaviours, which are used to describe each competency area.</p>

                    <h3 className='f5 mt4'>
                      <strong>Rating calculations</strong>
                    </h3>
                    <p>
                      When completing the online questionnaire, you rated each statement against a scale. These ratings are collated and averaged to show the
                      mean rating for each of the overall competencies.
                    </p>

                    <h3 className='f5 mt4'>
                      <strong>Unable to comment rating</strong>
                    </h3>
                    <p>
                      There are occasions where you may have felt unable to provide feedback to a specific statement. In these instances, you might
                      have selected the ‘unable to comment’ rating.
                    </p>
                    <p>
                      Whenever you choose this rating, it is not included in the rating calculation for that statement, or in the overall competency rating.
                    </p>
                  </div>
                  
                  {/* part 1 step 1 */}
                  <RelationshipCompetencyComparison
                    reportType='Self'
                    generateGraph={generateGraph}
                    completedRelationshipIDs={relationshipKeys}
                    current360Relationships={current360Relationships}
                    chartOptions={chartOptions}
                    captionsLoaded={captionsLoaded}
                    data={data}
                    convertSVGToImage={this.convertSVGToImage}
                    orderedSectionIDs={radarSortedSectionIDs}
                    numberOfSections={radarSortedSectionIDs.length}
                    pdfRequested={pdfRequested}
                    sectionDetails={sectionDetails}
                    captionKeysList={captionKeysList}
                    updateCompetencyComparisonPDFExportPreRenderStatus={this.updateCompetencyComparisonPDFExportPreRenderStatus}
                    layoutMode={layoutMode}
                  />

                  {/* part 1 step 2 */}
                  <RankedCompetencies
                    reportType='Self'
                    generateGraph={generateGraph}
                    answerKeys={Object.keys(withoutZero)}
                    sectionDetails={sectionDetails}
                    revieweeAnswersAverage={withoutZero}
                    updateRankedCompetenciesPDFExportPreRenderStatus={this.updateRankedCompetenciesPDFExportPreRenderStatus}
                    pdfRequested={pdfRequested}
                    layoutMode={layoutMode}
                  />

                  {/* Part 2 */}
                  <DetailedFeedbackSection
                    loading={this.state.loading}
                    reportType='Self'
                    sectionDetails={this.state.sectionDetails}
                    questionDetails={this.state.questionDetails}
                    freeTextQuestionDetails={this.state.freeTextQuestionDetails}
                    sectionsLegacyMode={this.state.sectionsLegacyMode}
                    secLengthNoFreeText={this.state.secLengthNoFreeText}
                    sectionAverageSelfCurrent={withoutZero}
                    sectionResponsesSelfCurrent={this.state.userResponses}
                    questionAveragesSelfCurrent={this.state.userIndividualAnswers}
                    userFreetextResponses={this.state.userCommentsBySection}
                    pdfRequested={this.state.pdfRequested}
                    updateDetailedFeedbackPDFExportPreRenderStatus={this.updateDetailedFeedbackPDFExportPreRenderStatus}
                    layoutMode={layoutMode}
                  />

                  {/* Part 3 */}
                  <TitlePage h1Text='Part 3:' h2Class=' mt4' h2Text='Your Development Plan' />
                  <div className='bg-white user-report__content'>
                    <PageHeader h2Class='mt4' h2Text='Your Development Plan' h3Text='Guide' line={true} />

                    <p>You need to create a development plan, with specific goals, to get the most out of your self-report.</p>
                    <p>There are three stages to creating an effective development plan:</p>
                    <p>
                      &bull; Reviewing your 360 Self-Report
                      <br />
                      &bull; Creating some SMART goals
                      <br />
                      &bull; Reviewing and tracking your progress
                    </p>
                    <p>If you follow these stages, particularly the regular review of your progress, you will get the most value from your feedback.</p>
                  </div>

                  <div className='page-break bg-white user-report__content'>
                    <PageHeader h2Class='mt4' h2Text='Part 3: ' strong='Step 1' h3Text='Review your report' line={true} />

                    <p>Go back through the notes, reflections and observations that you have made throughout your report.</p>
                    <p>
                      Use these to build a summary of the key messages that stand out from the assessment. This summary will help you to focus your thinking
                      when it comes to creating some relevant goals.
                    </p>

                    <DottedLines numberOfLines={16} />
                  </div>

                  <div className='page-break bg-white user-report__content'>
                    <PageHeader h2Class='mt4' h2Text='Part 3: ' strong='Step 2' h3Text='My goals' line={true} />

                    <p>
                      Use your summary findings to guide you through setting a small number of developmental goals that are stretching but achievable. The
                      statements in the report can form a sound basis for your goals. We recommend that you put some dates into your diary, to review your
                      progress on your developmental goals.
                    </p>
                  </div>

                  {/* maps through the array to print each goal from the respective function */}
                  {[1, 2, 3].map((n) => (
                    <Goals key={n} num={n} />
                  ))}

                  <div className='page-break bg-white user-report__content'>
                    <PageHeader h2Class='mt4' h2Text='Part 3: ' strong='Step 3' h3Text='Review progress on your development goals' line={true} />
                    <p>
                      Regularly reviewing progress on your development goals is recommended, as this will help you to see progress made and refocus on those
                      goals if necessary.
                    </p>
                  </div>

                  {/* maps through the array to print each goal review progress step from the respective function */}
                  {[1, 2, 3].map((n) => (
                    <GoalProgress key={n} num={n} />
                  ))}

                  <header className='page-break user-report__header'>
                    <img crossOrigin='anonymous' src={this.props.current360.settings.logo} className='header-logo-img' />
                    <div className='w-80'>
                      <h1 className='user-report__header-title'>Good Luck</h1>
                      <p className='user-report__header-sub-title'>
                        <strong>Own the change you want to see! </strong>
                      </p>
                    </div>
                  </header>
                </div>
              </PDFExport>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          {this.state.error ? (
            <div className='error-404 bg-blue fixed left-0 top-0'>
              <h1 className='white mt4'>System Error - Error loading report</h1>
            </div>
          ) : (
            <LoadingState />
          )}
        </div>
      );
    }
  }
}

export default withAuthorisation(authCondition)(SelfReport);
// export default User360Report
